import React, { useCallback } from 'react';
import HorizontalStack from '../../../horizontal-stack';
import IconButton from '../../../icon-button';

const GradientStopActions = ({ actions }) => {
  const handleActionButtonClick = useCallback(
    (onClick) => (e) => {
      e.stopPropagation();
      onClick();
    },
    []
  );

  return (
    <div className="ws-ui-gradient-stop-actions">
      <HorizontalStack gap="spacing-3-xs" verticalAlign="center">
        {actions.map(({ id, glyph, label, disabled = false, onClick }) => (
          <IconButton
            key={id}
            glyph={glyph}
            label={label}
            size="medium"
            appearance="light"
            transparent
            disabled={disabled}
            onClick={handleActionButtonClick(onClick)}
          />
        ))}
      </HorizontalStack>
    </div>
  );
};

GradientStopActions.displayName = 'GradientStopActions';

export default GradientStopActions;
